import useCasMutation, { IGenericMutationProps } from './useCasMutation';

export type DownloadFileProps = IGenericMutationProps & {
  url: string;
  params?: Record<string, any>;
  mimeType?: string;
};

const downloadFile = (base64Data: string, fileName: string, mimeType: string) => {
  try {
    if (!base64Data) throw new Error('No data to download.');

    // Decode base64 data
    const decodedData = atob(base64Data);

    // Convert the decoded data to a Uint8Array
    const uint8Array = new Uint8Array(decodedData.length);

    for (let i = 0; i < decodedData.length; i += 1) {
      uint8Array[i] = decodedData.charCodeAt(i);
    }

    const blob = new Blob([uint8Array], { type: mimeType });
    
    // Create a download link and simulate a click to download the file
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = fileName;
    downloadLink.click();
  } catch (error) {
    throw new Error('No data to download.');
  }
};

export default function useDownloadFileMutation({
  url,
  params,
  mimeType = 'application/octet-stream',
  onSuccess,
  ...rest
}: DownloadFileProps) {
  return useCasMutation({
    method: 'get',
    url,
    params,
    onSuccess: (data: any, variables: any, context: any) => {
      downloadFile(data.file, data.fileName, mimeType);
      onSuccess?.(data, variables, context);
    },
    ...rest,
  });
}
